import React from "react";

import { SvgProps } from "./types";

const BsmBackground: React.FC<SvgProps> = ({ height, width }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 473 443"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M473 -30H0V443H473V-30Z" fill="#F8F7F9" />
    <g opacity="0.5">
      <path
        opacity="0.4"
        d="M418.999 386.398C421.443 381.352 424.281 373.784 424.439 364.561C424.596 353.524 420.812 351.632 420.339 339.492C419.945 328.928 421.758 327.194 423.098 312.137C424.36 297.316 422.231 297.631 422.625 278.711C422.941 262.708 423.177 252.539 427.198 239.452C431.849 224.316 436.185 222.74 439.969 210.205C442.807 200.587 444.541 186.949 439.496 169.369"
        fill="#9E83C9"
      />
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M463.304 186.791C463.698 191.048 468.191 193.965 472.842 196.882C472.921 196.882 472.921 196.961 473 196.961V145.562C472.212 146.665 471.423 147.848 470.635 148.951C465.353 156.598 463.934 163.614 463.54 163.457C463.067 163.299 463.855 154.864 469.137 146.823C470.32 145.01 471.66 143.354 472.921 141.935V129.953C470.477 130.899 468.428 131.608 467.166 132.081C458.179 135.313 458.81 134.683 457.391 135.629C451.715 139.334 452.346 143.118 445.645 147.532C443.989 148.557 442.728 149.188 441.467 150.922C439.417 153.603 439.102 156.756 439.18 159.042C437.683 159.988 420.97 170.552 422.547 182.534C422.704 183.717 423.256 188.289 426.331 189.787C430.745 191.994 436.658 185.924 439.18 188.053C441.23 189.787 437.998 194.517 440.284 198.143C442.176 201.218 446.827 201.612 450.138 201.77C457.943 202.085 465.669 200.981 471.975 199.562C467.639 197.355 464.959 194.517 463.855 193.335C462.436 191.758 459.125 188.053 459.125 183.638C459.125 182.929 459.125 180.8 460.15 180.327C460.86 180.091 461.727 180.564 462.2 181.115C463.776 182.377 463.146 184.821 463.304 186.791ZM443.28 169.369C442.728 169.921 440.994 169.133 440.048 168.187C438.156 166.137 439.023 162.59 439.969 162.353C441.309 162.038 444.383 168.266 443.28 169.369Z"
          fill="#534766"
        />
      </g>
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M357.746 136.102C357.824 136.102 357.824 136.181 357.903 136.181C358.77 136.654 362.318 138.467 367.521 139.649C369.334 140.043 370.911 140.28 383.524 140.122C406.622 139.965 389.594 139.413 397.714 139.334C400.394 139.334 403.863 139.334 404.73 137.521C405.282 136.259 404.336 134.998 405.203 132.475C405.44 131.766 405.834 130.583 406.543 130.505C407.647 130.426 407.726 133.973 409.776 135.55C411.904 137.205 415.136 136.023 420.891 134.052C435.239 129.243 434.293 130.032 435.948 129.007C437.998 127.667 444.068 123.41 447.221 115.29C448.089 113.082 448.562 111.033 448.877 109.22C444.778 111.033 440.284 111.821 435.318 112.688C433.031 113.082 429.72 113.477 425.7 113.634C427.75 112.688 430.982 111.269 435.002 110.008C439.969 108.51 442.334 108.352 445.645 107.406C446.67 107.091 447.931 106.697 449.192 106.145C449.192 105.987 449.192 105.751 449.192 105.593C450.059 105.357 451.321 104.805 452.424 103.78C455.814 100.706 455.184 95.3449 454.868 92.3492C454.632 90.1419 453.843 82.6527 449.35 78.0804C444.541 80.603 441.23 82.8104 438.865 84.6235C437.84 85.4119 435.16 87.5404 431.218 90.1419C430.666 90.4572 429.011 91.6397 424.833 94.2412C422.468 95.739 419.157 97.7099 415.215 100.154C417.265 97.631 420.576 94.0047 425.385 90.536C428.38 88.4075 430.666 87.1462 433.583 85.6484C437.21 83.6775 442.334 80.9184 448.562 77.292C447.931 76.7402 447.221 76.2672 446.512 75.873C443.595 74.2964 443.674 75.9519 434.45 73.7445C433.583 73.508 432.795 73.3504 432.007 73.1139C429.957 74.3752 428.459 75.5577 427.434 76.5037C422.074 81.2337 419.787 84.7024 419.787 84.7024C418.763 86.2002 417.895 87.7769 416.003 89.4324C413.954 91.2455 411.825 92.2704 410.249 92.901C411.589 90.4572 413.56 87.0674 416.634 83.441C417.58 82.3374 419.157 80.5242 422.547 77.3709C424.044 75.9519 425.858 74.3752 427.986 72.6409C427.434 72.6409 426.804 72.7197 426.173 72.7985C424.675 73.1139 424.596 73.3504 420.812 74.454C417.422 75.4 417.028 75.2424 415.767 75.9519C413.796 76.9767 412.614 78.3169 411.352 79.7359C408.672 82.8104 409.381 83.441 407.726 84.7812C406.938 85.4119 405.676 86.2002 397.556 86.752C392.59 87.0674 393.142 86.8309 390.856 87.0674C386.677 87.6192 385.022 88.5652 383.288 89.0382C384.47 89.9054 385.495 90.7725 386.283 91.482C384.155 91.6397 380.923 91.5609 377.296 90.2995C374.616 89.4324 372.33 88.0922 370.595 86.8309C368.073 87.6192 366.654 89.6689 362.554 90.6149C360.426 91.0879 358.613 91.0879 358.297 91.0879C356.642 91.009 356.327 90.7725 355.696 90.7725C355.223 90.7725 354.829 90.9302 354.435 91.2455C355.302 91.7974 356.327 92.1915 357.509 92.428C360.662 93.1375 361.766 91.8762 366.181 92.7434C369.413 93.374 370.753 94.3989 373.828 95.8179C382.972 99.9172 390.383 99.3654 390.304 100.548C390.304 101.179 388.096 101.809 386.362 101.888C384.155 101.967 383.288 101.1 380.607 100.233C377.296 99.2077 374.537 99.2077 372.803 99.2865C371.068 99.2865 370.201 99.523 366.417 100.075C366.417 100.075 363.579 100.548 356.8 101.573C354.671 101.888 351.833 102.282 348.364 102.598C348.049 103.386 347.655 104.174 347.34 105.041C346.709 106.382 346.236 107.485 345.842 108.352C349.074 108.668 353.094 108.747 357.509 108.116C363.737 107.249 366.654 105.436 373.039 105.987C375.483 106.224 375.404 106.46 379.582 106.933C384.076 107.406 386.677 107.406 388.096 109.22C388.569 109.771 389.042 110.796 388.727 111.19C388.412 111.585 387.229 111.112 386.599 110.875C384.155 109.929 381.553 109.614 376.271 109.062C374.379 108.825 373.039 108.904 370.359 108.904C369.098 108.904 366.89 108.983 360.584 109.535C356.484 109.85 355.932 110.008 354.513 110.087C352.148 110.244 348.916 110.323 345.053 109.929C344.029 112.058 343.713 112.846 343.556 114.501C343.319 117.182 343.713 119.547 344.344 121.439C345.763 121.202 347.261 120.887 348.759 120.572C354.513 119.231 354.435 118.443 361.214 116.945C370.122 115.053 375.641 115.369 378.558 115.605C381.238 115.92 383.524 116.393 385.101 116.788C383.603 117.261 381.317 118.049 378.4 118.601C372.093 119.862 369.334 119.074 363.5 119.547C360.82 119.783 356.8 120.808 348.759 122.779C347.497 123.094 346.315 123.41 345.211 123.725C345.526 124.513 345.921 125.144 346.157 125.617C348.049 129.086 350.493 131.451 352.937 133.185C354.829 133.264 357.115 133.106 359.716 132.318C362.239 131.529 362.712 130.978 371.147 127.903C373.118 127.194 374.695 126.642 376.666 126.09C380.055 125.223 382.972 124.829 385.022 124.592C384.47 125.459 383.524 126.721 382.105 127.824C379.267 130.189 376.271 130.82 374.301 131.293C374.301 131.293 367.442 132.791 361.687 134.525C360.189 134.919 358.928 135.471 357.746 136.102ZM417.028 109.693C419.472 105.83 422.074 103.622 423.887 102.361C426.173 100.784 427.828 100.233 434.687 97.3157C437.998 95.8967 440.599 94.7142 442.176 94.0835C438.471 98.8924 434.845 101.179 432.007 102.44C429.799 103.386 428.301 103.622 425.148 105.041C421.601 106.539 418.841 108.352 417.028 109.693Z"
          fill="#423B4D"
        />
      </g>
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M298.069 285.254C298.778 284.23 300.197 282.574 302.484 281.313C303.745 280.682 304.454 280.524 305.873 280.13C306.741 278.159 308.081 275.873 309.5 273.902C312.18 270.197 314.308 268.778 318.723 264.679C321.088 262.472 324.478 259.161 328.341 254.746C327.08 256.953 325.739 259.161 324.478 261.368C321.561 266.256 318.566 271.064 315.649 275.637C318.802 273.981 320.615 273.035 322.271 271.932C327.158 268.542 328.026 266.177 331.1 264.285C332.283 262.156 333.307 260.343 334.017 258.845C337.722 251.514 338.826 247.572 343.004 243.394C345.527 240.871 348.128 239.295 349.862 238.349C349.468 240.083 348.68 242.763 347.419 245.759C345.054 251.198 342.61 253.485 339.693 258.609C339.22 259.476 338.668 260.501 338.037 261.683C338.195 261.604 338.274 261.604 338.431 261.526C340.639 260.501 341.585 259.791 346.078 256.717C354.119 251.198 354.514 251.277 356.327 249.385C357.824 247.887 358.219 247.099 359.716 246.311C359.874 246.232 359.953 246.153 360.111 246.153C360.584 245.365 361.135 244.419 361.766 243.473C363.816 240.241 364.21 239.689 364.919 238.27C366.654 234.486 367.206 231.017 367.284 228.652C369.176 227.864 371.069 227.154 373.039 226.366C372.251 229.756 371.384 233.224 370.359 236.851C369.492 239.768 368.625 242.527 367.679 245.286C369.649 244.261 372.015 242.921 374.616 241.423C376.508 240.319 379.346 238.664 382.894 236.299C386.283 234.092 388.885 232.357 391.171 230.781C391.486 229.992 391.802 229.125 391.959 228.258C392.826 224.395 391.959 221.084 391.329 219.35C391.88 218.798 393.142 217.773 394.245 218.088C395.191 218.325 395.664 219.429 396.532 222.345C396.926 223.686 397.32 224.789 397.556 225.656C399.527 223.843 402.523 221.084 405.676 216.748C408.514 212.807 412.929 206.579 413.165 199.799C409.618 202.558 406.07 205.239 402.444 207.998C401.656 207.525 400.946 207.131 400.158 206.658C402.129 205.79 407.095 203.347 410.564 197.749C411.273 196.567 411.904 195.384 412.298 194.281C411.983 193.414 411.51 192.31 410.8 191.049C410.17 189.945 407.174 185.057 401.735 183.008C397.951 181.667 397.793 183.402 389.673 182.771C387.86 182.613 386.52 182.456 385.416 182.298C385.81 183.402 386.126 184.584 386.283 185.924C386.756 189.866 385.337 193.177 384.47 194.911C384.864 192.625 385.18 189.393 384.47 185.688C384.234 184.348 383.839 183.086 383.445 181.983C381.947 181.746 380.765 181.667 378.873 182.062C375.089 182.771 375.72 183.875 371.305 184.9C366.496 186.082 364.525 185.057 359.874 186.476C357.746 187.186 356.09 187.974 355.065 188.605C355.696 188.841 356.484 189.157 357.351 189.63C356.327 190.103 355.302 190.654 354.592 191.285C352.7 192.862 352.937 193.965 351.202 196.252C349.626 198.38 348.207 199.011 342.767 202.164C340.718 203.347 337.801 205.081 334.174 207.367C338.51 205.475 341.742 205.948 343.161 206.263C347.497 207.288 350.493 210.678 353.883 214.462C355.144 215.881 356.09 217.221 356.721 218.01C354.908 216.985 352.306 215.566 349.153 213.989C343.398 211.072 342.216 210.836 341.033 211.072C339.614 211.309 338.51 212.097 334.174 217.379C328.971 223.607 329.839 223.37 327.947 225.262C323.374 229.598 320.773 228.889 317.777 232.83C319.117 232.751 320.852 232.515 322.98 232.121C327.474 231.332 329.366 230.544 333.386 230.781C335.988 230.859 339.378 231.411 339.378 232.042C339.378 232.2 339.22 232.515 337.091 233.067C333.15 234.092 329.996 234.013 329.05 234.013C324.872 234.013 321.167 234.722 319.748 235.195C318.487 235.589 317.068 236.22 315.491 237.324C315.255 237.954 314.939 238.664 314.624 239.452C311.944 246.074 312.732 246.311 310.84 250.41C308.869 254.588 307.45 255.771 306.189 259.476C307.608 258.53 309.027 257.663 310.446 256.717C313.284 254.904 316.201 253.012 318.96 251.198C318.881 251.829 318.644 252.775 318.093 253.8C316.358 256.953 312.653 257.742 311.076 258.372C309.263 259.082 307.214 260.501 305.164 263.733C305.085 264.048 305.006 264.442 304.927 264.915C302.799 276.267 301.616 279.105 300.907 280.603C300.197 281.549 299.409 283.284 298.069 285.254ZM365.392 199.168C364.052 196.646 363.816 194.517 363.501 192.783C365.393 194.044 367.521 195.7 369.255 197.749C372.251 201.218 374.458 205.869 373.749 206.5C372.882 207.131 367.994 204.056 365.392 199.168Z"
          fill="#645280"
        />
      </g>
      <path
        opacity="0.4"
        d="M392.59 389.551C393.221 382.85 394.246 372.602 395.586 360.225C397.478 342.33 398.03 339.492 398.581 333.894C400.946 308.747 397.557 288.092 396.059 279.105C391.092 249.464 383.682 242.606 388.096 229.44C388.885 226.997 392.038 218.798 392.196 207.603C392.275 202.479 391.723 198.301 391.25 195.621"
        fill="#9E83C9"
      />
      <path
        opacity="0.4"
        d="M411.274 390.024C412.771 376.07 413.717 355.101 409.933 329.874C407.095 311.269 404.415 308.589 402.208 294.714C396.374 258.372 409.066 241.738 413.165 206.815C415.215 189.63 415.531 164.403 406.307 132.791"
        fill="#9E83C9"
      />
      <path
        opacity="0.8"
        d="M395.034 442.685H424.281C436.816 442.685 446.985 432.515 446.985 419.981V388.211C446.985 383.796 443.359 380.17 438.944 380.17H380.292C375.877 380.17 372.251 383.796 372.251 388.211V419.981C372.33 432.515 382.499 442.685 395.034 442.685Z"
        fill="#9D90B0"
      />
      <path
        d="M372.361 420.567L447.016 420.567L447.016 402.278L372.361 402.278L372.361 420.567Z"
        fill="#D3C8E3"
      />
    </g>
    <path
      opacity="0.2"
      d="M0.630676 442.212C0.630676 433.855 85.2977 426.997 189.752 426.997C294.206 426.997 378.873 433.776 378.873 442.212H0.630676Z"
      fill="url(#paint0_radial)"
    />
    <path
      opacity="0.2"
      d="M95.9402 442.212C95.9402 437.639 137.958 434.013 189.752 434.013C241.545 434.013 283.564 437.718 283.564 442.212H95.9402Z"
      fill="url(#paint1_radial)"
    />
    <path
      d="M198.354 426.987L198.355 318.276L178.016 318.276L178.015 426.987L198.354 426.987Z"
      fill="#757575"
    />
    <path
      d="M248.798 351.002H127.631C117.304 351.002 108.948 342.645 108.948 332.318V323.173C108.948 317.97 113.126 313.792 118.329 313.792H258.258C263.461 313.792 267.639 317.97 267.639 323.173V332.318C267.481 342.566 259.125 351.002 248.798 351.002Z"
      fill="#5E5E5E"
    />
    <path
      d="M274.025 435.747L198.266 412.413V391.601L274.025 421.951V435.747Z"
      fill="#808080"
    />
    <path
      d="M273.473 440.635C280.265 440.635 285.771 435.129 285.771 428.337C285.771 421.545 280.265 416.039 273.473 416.039C266.681 416.039 261.175 421.545 261.175 428.337C261.175 435.129 266.681 440.635 273.473 440.635Z"
      fill="#666666"
    />
    <path
      d="M101.853 435.747L177.69 412.413V391.601L101.853 421.951V435.747Z"
      fill="#808080"
    />
    <path
      d="M102.483 440.635C109.275 440.635 114.781 435.129 114.781 428.337C114.781 421.545 109.275 416.039 102.483 416.039C95.6913 416.039 90.1853 421.545 90.1853 428.337C90.1853 435.129 95.6913 440.635 102.483 440.635Z"
      fill="#666666"
    />
    <path
      d="M187.229 144.064C165.944 144.064 148.601 126.8 148.601 105.436V93.7685C148.601 72.4835 165.865 55.1401 187.229 55.1401C208.514 55.1401 225.858 72.4046 225.858 93.7685V105.436C225.858 126.8 208.514 144.064 187.229 144.064Z"
      fill="#AA7663"
    />
    <path
      d="M155.696 90.4573H146.315V99.6019H155.696V90.4573Z"
      fill="#382620"
    />
    <path
      d="M219.987 99.6372L229.368 99.6372L229.368 90.4926L219.987 90.4926L219.987 99.6372Z"
      fill="#382620"
    />
    <path
      d="M225.858 117.182C230.386 117.182 234.056 112.982 234.056 107.801C234.056 102.62 230.386 98.4194 225.858 98.4194C221.33 98.4194 217.659 102.62 217.659 107.801C217.659 112.982 221.33 117.182 225.858 117.182Z"
      fill="#AA7663"
    />
    <g opacity="0.5">
      <path
        opacity="0.5"
        d="M225.858 109.771C226.815 109.771 227.592 108.889 227.592 107.801C227.592 106.712 226.815 105.83 225.858 105.83C224.9 105.83 224.123 106.712 224.123 107.801C224.123 108.889 224.9 109.771 225.858 109.771Z"
        fill="#4D4D4D"
      />
    </g>
    <path
      d="M219.945 118.364L223.493 114.896V97.3159H219.945V118.364Z"
      fill="#382620"
    />
    <path
      opacity="0.3"
      d="M190.777 57.5052C177.927 54.1153 160.662 57.9782 153.331 70.355C148.364 78.7902 148.286 90.694 152.148 92.586C156.09 94.478 160.505 84.2297 174.379 77.3712C191.25 69.0148 206.07 73.666 207.095 69.1725C207.962 65.625 199.054 59.7125 190.777 57.5052Z"
      fill="#995C44"
    />
    <path
      d="M183.209 69.9608C194.616 69.9608 203.863 60.7135 203.863 49.3064C203.863 37.8994 194.616 28.6521 183.209 28.6521C171.802 28.6521 162.554 37.8994 162.554 49.3064C162.554 60.7135 171.802 69.9608 183.209 69.9608Z"
      fill="#382620"
    />
    <path
      d="M203.469 72.5623C214.876 72.5623 224.123 63.3151 224.123 51.908C224.123 40.5009 214.876 31.2537 203.469 31.2537C192.062 31.2537 182.814 40.5009 182.814 51.908C182.814 63.3151 192.062 72.5623 203.469 72.5623Z"
      fill="#382620"
    />
    <path
      d="M222.783 85.7274C234.19 85.7274 243.437 76.4801 243.437 65.073C243.437 53.666 234.19 44.4187 222.783 44.4187C211.376 44.4187 202.129 53.666 202.129 65.073C202.129 76.4801 211.376 85.7274 222.783 85.7274Z"
      fill="#382620"
    />
    <path
      d="M162.081 77.8441C173.488 77.8441 182.736 68.5968 182.736 57.1897C182.736 45.7827 173.488 36.5354 162.081 36.5354C150.674 36.5354 141.427 45.7827 141.427 57.1897C141.427 68.5968 150.674 77.8441 162.081 77.8441Z"
      fill="#382620"
    />
    <path
      d="M150.651 83.993C162.058 83.993 171.305 74.7457 171.305 63.3387C171.305 51.9316 162.058 42.6843 150.651 42.6843C139.243 42.6843 129.996 51.9316 129.996 63.3387C129.996 74.7457 139.243 83.993 150.651 83.993Z"
      fill="#382620"
    />
    <path
      d="M160.792 84.236C163.802 76.2979 159.807 67.4229 151.869 64.4132C143.93 61.4035 135.055 65.3988 132.046 73.3369C129.036 81.2751 133.031 90.1501 140.969 93.1598C148.908 96.1695 157.783 92.1742 160.792 84.236Z"
      fill="#382620"
    />
    <path
      d="M241.473 84.2929C244.482 76.3548 240.487 67.4798 232.549 64.4701C224.611 61.4604 215.736 65.4557 212.726 73.3938C209.716 81.332 213.712 90.2069 221.65 93.2166C229.588 96.2263 238.463 92.231 241.473 84.2929Z"
      fill="#382620"
    />
    <path
      d="M148.601 117.182C153.129 117.182 156.799 112.982 156.799 107.801C156.799 102.62 153.129 98.4194 148.601 98.4194C144.073 98.4194 140.402 102.62 140.402 107.801C140.402 112.982 144.073 117.182 148.601 117.182Z"
      fill="#AA7663"
    />
    <path
      opacity="0.5"
      d="M148.601 109.771C149.559 109.771 150.335 108.889 150.335 107.801C150.335 106.712 149.559 105.83 148.601 105.83C147.643 105.83 146.867 106.712 146.867 107.801C146.867 108.889 147.643 109.771 148.601 109.771Z"
      fill="#4D4D4D"
    />
    <path
      d="M155.617 118.364L152.148 114.896V97.3159H155.617V118.364Z"
      fill="#382620"
    />
    <path
      d="M204.021 149.031H170.832V163.299H204.021V149.031Z"
      fill="#39277D"
    />
    <path
      d="M228.853 287.068H144.659C142.058 287.068 139.929 284.781 140.008 281.943C140.481 214.068 149.783 167.556 149.783 167.556C150.178 162.353 154.277 158.333 159.086 158.333H214.427C219.314 158.333 223.335 162.353 223.729 167.556C223.729 167.556 233.031 214.068 233.504 281.943C233.504 284.781 231.455 287.068 228.853 287.068Z"
      fill="#AA7663"
    />
    <path
      d="M167.442 102.71C169.706 102.71 171.541 100.875 171.541 98.611C171.541 96.347 169.706 94.5117 167.442 94.5117C165.178 94.5117 163.343 96.347 163.343 98.611C163.343 100.875 165.178 102.71 167.442 102.71Z"
      fill="#4D4D4D"
    />
    <path
      d="M205.992 102.71C208.256 102.71 210.091 100.875 210.091 98.6111C210.091 96.3471 208.256 94.5117 205.992 94.5117C203.728 94.5117 201.892 96.3471 201.892 98.6111C201.892 100.875 203.728 102.71 205.992 102.71Z"
      fill="#4D4D4D"
    />
    <path
      d="M143.713 310.796L125.818 329.322L220.812 421.242C225.936 426.208 234.056 426.051 239.023 420.927C243.989 415.802 243.832 407.683 238.707 402.716L143.713 310.796Z"
      fill="#AA7663"
    />
    <path
      d="M134.805 332.87C141.902 332.87 147.655 327.117 147.655 320.02C147.655 312.923 141.902 307.17 134.805 307.17C127.708 307.17 121.955 312.923 121.955 320.02C121.955 327.117 127.708 332.87 134.805 332.87Z"
      fill="#AA7663"
    />
    <path
      d="M155.696 303.938L131.258 295.976L122.586 315.999L147.024 324.04L155.696 303.938Z"
      fill="#AA7663"
    />
    <path
      d="M143.477 312.767C150.573 312.767 156.327 307.014 156.327 299.917C156.327 292.821 150.573 287.068 143.477 287.068C136.38 287.068 130.627 292.821 130.627 299.917C130.627 307.014 136.38 312.767 143.477 312.767Z"
      fill="#AA7663"
    />
    <path
      d="M229.957 310.796L247.852 329.322L152.937 421.163C147.813 426.13 139.693 425.972 134.726 420.848C129.76 415.724 129.917 407.604 135.042 402.637L229.957 310.796Z"
      fill="#AA7663"
    />
    <path
      d="M238.944 332.87C246.041 332.87 251.794 327.117 251.794 320.02C251.794 312.923 246.041 307.17 238.944 307.17C231.847 307.17 226.094 312.923 226.094 320.02C226.094 327.117 231.847 332.87 238.944 332.87Z"
      fill="#AA7663"
    />
    <path
      d="M218.053 303.938L242.491 295.976L251.163 315.999L226.646 324.04L218.053 303.938Z"
      fill="#AA7663"
    />
    <path
      d="M230.272 312.767C237.369 312.767 243.122 307.014 243.122 299.917C243.122 292.821 237.369 287.068 230.272 287.068C223.175 287.068 217.422 292.821 217.422 299.917C217.422 307.014 223.175 312.767 230.272 312.767Z"
      fill="#AA7663"
    />
    <path
      d="M158.692 176.859C163.873 176.859 168.073 172.659 168.073 167.478C168.073 162.297 163.873 158.096 158.692 158.096C153.51 158.096 149.31 162.297 149.31 167.478C149.31 172.659 153.51 176.859 158.692 176.859Z"
      fill="#AA7663"
    />
    <path
      d="M163.35 175.529L153.909 159.405L75.1946 205.493L84.6354 221.617L163.35 175.529Z"
      fill="#AA7663"
    />
    <path
      d="M214.821 176.859C220.002 176.859 224.202 172.659 224.202 167.478C224.202 162.297 220.002 158.096 214.821 158.096C209.64 158.096 205.44 162.297 205.44 167.478C205.44 172.659 209.64 176.859 214.821 176.859Z"
      fill="#AA7663"
    />
    <path
      d="M288.683 221.82L298.155 205.715L219.532 159.471L210.06 175.576L288.683 221.82Z"
      fill="#AA7663"
    />
    <path
      d="M293.418 223.134C298.599 223.134 302.799 218.934 302.799 213.753C302.799 208.572 298.599 204.372 293.418 204.372C288.237 204.372 284.036 208.572 284.036 213.753C284.036 218.934 288.237 223.134 293.418 223.134Z"
      fill="#AA7663"
    />
    <path
      d="M291.683 235.905C296.808 236.22 301.301 232.357 301.616 227.154L302.799 214.305L284.115 213.043L282.933 225.893C282.618 231.096 286.48 235.59 291.683 235.905Z"
      fill="#AA7663"
    />
    <path
      d="M305.952 233.934H277.888V239.768H305.952V233.934Z"
      fill="#636363"
    />
    <path
      d="M277.888 233.934C277.888 226.208 284.194 219.902 291.92 219.902C299.645 219.902 305.952 226.208 305.952 233.934H277.888Z"
      fill="#474747"
    />
    <path
      d="M287.663 216.591C289.082 216.591 290.264 217.773 290.264 219.192V226.129C290.264 227.548 289.082 228.731 287.663 228.731C286.244 228.731 285.061 227.548 285.061 226.129V219.192C285.061 217.773 286.244 216.591 287.663 216.591Z"
      fill="#AA7663"
    />
    <path
      d="M294.443 217.615H294.679C296.098 217.615 297.202 218.719 297.202 220.138V226.287C297.202 227.706 296.098 228.81 294.679 228.81H294.443C293.024 228.81 291.92 227.706 291.92 226.287V220.138C291.92 218.798 293.102 217.615 294.443 217.615Z"
      fill="#AA7663"
    />
    <path
      d="M275.286 231.884C276.705 231.884 277.888 233.067 277.888 234.486V235.905C277.888 237.324 276.705 238.506 275.286 238.506C273.867 238.506 272.685 237.324 272.685 235.905V234.486C272.606 233.067 273.788 231.884 275.286 231.884Z"
      fill="#AA7663"
    />
    <path
      d="M101.064 433.855L156.248 434.092L156.327 409.89L130.627 409.811C129.05 417.695 124.714 420.06 122.665 420.533C119.59 421.321 117.462 417.852 112.889 416.749C112.18 416.591 111.392 416.433 110.524 416.433C109.815 416.433 104.218 416.354 101.064 420.375C98.4629 423.844 98.4629 429.204 101.064 433.855Z"
      fill="#999999"
    />
    <path
      d="M103.745 441.975L152.148 442.212C154.356 442.212 156.169 440.399 156.169 438.191V434.171L100.986 433.934V439.295C101.064 440.714 102.247 441.975 103.745 441.975Z"
      fill="#F2F2F2"
    />
    <path
      d="M136.145 431.648H139.062L133.307 421.557H130.39L136.145 431.648Z"
      fill="white"
    />
    <path
      d="M131.809 431.648H134.726L128.971 421.557H126.055L131.809 431.648Z"
      fill="white"
    />
    <path
      d="M127.474 431.648H130.39L124.636 421.557H121.798L127.474 431.648Z"
      fill="white"
    />
    <path
      d="M275.838 411.703L226.094 435.511L215.609 413.674L238.786 402.558C243.595 409.023 248.483 409.259 250.532 408.865C253.686 408.234 254.08 404.135 257.706 401.297C258.258 400.824 258.889 400.351 259.677 400.036C260.308 399.72 265.353 397.277 269.925 399.563C273.946 401.534 276.232 406.342 275.838 411.703Z"
      fill="#999999"
    />
    <path
      d="M276.863 420.138L233.189 441.029C231.139 441.975 228.774 441.108 227.828 439.137L226.094 435.511L275.838 411.703L278.124 416.591C278.833 417.852 278.203 419.508 276.863 420.138Z"
      fill="#F2F2F2"
    />
    <path
      d="M243.201 424.711L240.599 425.893L241.467 414.305L244.068 413.122L243.201 424.711Z"
      fill="white"
    />
    <path
      d="M247.064 422.819L244.462 424.08L245.329 412.492L247.931 411.23L247.064 422.819Z"
      fill="white"
    />
    <path
      d="M251.005 421.005L248.404 422.188L249.271 410.599L251.873 409.417L251.005 421.005Z"
      fill="white"
    />
    <path
      d="M186.756 168.345C181.553 168.345 177.375 164.167 177.375 158.964V140.832H196.059V158.964C196.059 164.167 191.88 168.345 186.756 168.345Z"
      fill="#AA7663"
    />
    <path
      opacity="0.3"
      d="M186.756 143.197C183.524 143.197 180.371 142.803 177.375 142.014V147.848C180.371 148.558 183.524 149.031 186.756 149.031C189.988 149.031 193.142 148.636 196.137 147.848V142.014C193.063 142.803 189.988 143.197 186.756 143.197Z"
      fill="#53392F"
    />
    <path
      d="M177.375 255.771H158.691V274.455H177.375V255.771Z"
      fill="#EB8F6A"
    />
    <path
      d="M196.059 255.771H177.375V274.455H196.059V255.771Z"
      fill="#FF8E61"
    />
    <path
      d="M214.742 255.771H196.058V274.455H214.742V255.771Z"
      fill="#FF9B73"
    />
    <path
      d="M177.375 274.455H158.691V293.138H177.375V274.455Z"
      fill="#E38A66"
    />
    <path
      d="M196.059 274.455H177.375V293.138H196.059V274.455Z"
      fill="#D68261"
    />
    <path
      d="M214.742 274.455H196.058V293.138H214.742V274.455Z"
      fill="#FFA987"
    />
    <path d="M177.375 293.217H158.691V311.9H177.375V293.217Z" fill="#D97750" />
    <path d="M196.059 293.217H177.375V311.9H196.059V293.217Z" fill="#E87D51" />
    <path d="M214.742 293.217H196.058V311.9H214.742V293.217Z" fill="#D67953" />
    <path
      d="M277.02 190.655L224.833 160.619C220.339 158.254 215.373 156.993 210.248 156.993H198.423L187.071 172.208L174.222 156.993H165.865C159.401 156.993 153.015 158.648 147.418 161.88L96.492 190.655L110.84 211.072L141.348 196.567C141.348 196.567 140.481 219.035 138.983 231.648C137.485 244.261 131.573 265.152 131.573 265.152C131.573 265.152 161.608 269.646 188.175 269.646C214.742 269.646 239.101 266.335 239.101 266.335L233.425 231.569L228.932 195.069L264.88 213.122L277.02 190.655Z"
      fill="#4F1DAF"
    />
    <path
      d="M252.188 314.029H121.876L133.544 256.953H239.338L252.188 314.029Z"
      fill="#072461"
    />
    <path
      d="M244.935 337.521L214.427 369.449L204.415 379.933L187.308 397.829L174.379 411.388L158.692 427.785L126.133 406.106L140.639 389.551L159.401 368.266L171.384 354.628L176.429 348.873L187.15 336.654L211.983 308.353L190.777 294.399L187.466 292.271L161.135 274.927L133.544 256.953H239.259L240.442 260.659L245.96 277.45L253.37 299.918C253.764 301.021 254.08 302.125 254.316 303.229C257.154 315.448 253.686 328.376 244.935 337.521Z"
      fill="#383285"
    />
    <path
      opacity="0.2"
      d="M254.395 303.229C247.458 303.702 238.865 304.411 230.036 310.797C221.679 316.788 224.833 319.468 208.908 334.841C201.025 342.488 197.793 344.222 193.299 351.159C189.515 356.993 188.885 360.225 185.653 361.25C181.396 362.511 175.01 359.2 171.305 354.628L176.35 348.873L187.072 336.654L211.904 308.353L190.698 294.399C185.574 283.993 176.429 280.682 177.375 274.454C179.188 263.024 214.033 250.647 240.521 260.58L246.039 277.371L253.449 299.839C253.764 301.021 254.08 302.125 254.395 303.229Z"
      fill="#380F17"
    />
    <path
      opacity="0.2"
      d="M204.415 379.933L187.308 397.829L174.379 411.388L140.639 389.551L159.401 368.266L176.429 348.873C184.076 357.702 197.162 372.05 204.415 379.933Z"
      fill="#380F17"
    />
    <path
      d="M243.122 403.82L224.202 417.695L213.796 425.814L187.308 397.829L159.322 368.266L128.262 335.471C119.984 326.721 116.91 314.186 120.3 302.598L120.852 300.785L128.341 275.085L133.623 256.953L239.338 257.269L211.904 275.716L187.387 292.271L163.5 308.353L187.072 336.654L214.427 369.449L243.122 403.82Z"
      fill="#403999"
    />
    <path
      opacity="0.3"
      d="M246.039 277.45C238.471 279.342 227.75 281.707 214.742 283.363C199.764 285.333 183.603 287.383 163.422 284.545C154.75 283.363 142.531 280.84 128.341 275.006L133.623 256.875H239.338L246.039 277.45Z"
      fill="#380F17"
    />
    <path
      opacity="0.2"
      d="M222.783 418.798L213.796 425.814L187.308 397.828L159.322 368.266L128.262 335.471C119.984 326.721 116.91 314.186 120.3 302.598L120.852 300.785C124.084 302.519 127.552 305.12 129.444 309.22C132.44 315.763 128.341 319.626 131.494 326.563C133.859 331.608 138.037 334.131 140.875 335.944C144.423 338.23 142.61 337.521 167.6 362.984C186.52 382.219 192.038 387.186 201.262 396.646C210.012 405.554 216.24 411.94 222.783 418.798Z"
      fill="#380F17"
    />
    <path
      d="M79.937 222.976C85.1181 222.976 89.3182 218.776 89.3182 213.595C89.3182 208.414 85.1181 204.214 79.937 204.214C74.7559 204.214 70.5558 208.414 70.5558 213.595C70.5558 218.776 74.7559 222.976 79.937 222.976Z"
      fill="#AA7663"
    />
    <path
      d="M161.845 226.129C162.239 224.71 163.658 223.843 165.077 224.237L178.006 227.627C179.425 228.021 180.292 229.44 179.898 230.859C179.504 232.278 178.085 233.145 176.666 232.751L163.737 229.361C162.318 228.967 161.451 227.548 161.845 226.129Z"
      fill="#AA7663"
    />
    <path
      d="M160.505 231.253C160.899 229.834 162.318 228.967 163.737 229.361L182.263 234.17C183.682 234.564 184.549 235.983 184.155 237.402C183.761 238.821 182.341 239.689 180.922 239.294L162.397 234.486C160.978 234.091 160.189 232.672 160.505 231.253Z"
      fill="#AA7663"
    />
    <path
      d="M159.165 236.377C159.559 234.958 160.978 234.091 162.397 234.485L183.918 240.082C185.337 240.477 186.204 241.896 185.81 243.315C185.416 244.734 183.997 245.601 182.578 245.207L161.057 239.609C159.716 239.215 158.849 237.717 159.165 236.377Z"
      fill="#AA7663"
    />
    <path
      d="M157.824 241.502L157.903 241.344C158.218 240.004 159.637 239.137 160.978 239.531L178.006 243.945C179.346 244.261 180.213 245.68 179.819 247.02L179.74 247.178C179.425 248.518 178.006 249.385 176.665 248.991L159.637 244.576C158.297 244.261 157.509 242.921 157.824 241.502Z"
      fill="#AA7663"
    />
    <path
      d="M151.202 241.738C153.252 245.443 158.14 254.194 158.14 254.194C158.14 254.194 163.343 254.351 160.347 246.547C157.351 238.742 152.937 238.9 152.937 238.9C152.937 238.9 149.547 238.9 151.202 241.738Z"
      fill="#AA7663"
    />
    <path
      d="M154.829 244.813C148.837 243.236 145.211 237.087 146.788 231.096C148.364 225.104 154.513 221.478 160.505 223.055C163.5 223.843 164.841 224.158 167.679 224.947C169.807 225.498 167.363 233.303 166.654 236.299C164.998 242.29 160.82 246.389 154.829 244.813Z"
      fill="#AA7663"
    />
    <path
      d="M154.671 232.988C153.41 237.954 148.285 241.029 143.24 239.689L77.572 222.661L82.302 204.529L147.97 221.557C152.937 222.897 155.932 228.021 154.671 232.988Z"
      fill="#AA7663"
    />
    <path
      d="M187.15 172.208L195.743 175.203L191.486 167.162L187.15 172.208Z"
      fill="#39277D"
    />
    <path
      d="M204.021 149.031L191.486 167.162L195.743 175.203L208.356 157.15L204.021 149.031Z"
      fill="#4F1DAF"
    />
    <path
      d="M187.15 172.208L177.454 176.386L182.893 167.162L187.15 172.208Z"
      fill="#39277D"
    />
    <path
      d="M170.832 149.031L182.893 167.162L177.454 176.386L166.023 157.15L170.832 149.031Z"
      fill="#4F1DAF"
    />
    <path d="M189.673 172.208H187.15V256.953H189.673V172.208Z" fill="#39277D" />
    <path
      d="M188.491 122.892H184.943C181.396 122.892 178.558 120.054 178.558 116.506C178.558 114.851 179.898 113.511 181.553 113.511H192.038C193.694 113.511 195.034 114.851 195.034 116.506C194.876 120.054 192.038 122.892 188.491 122.892Z"
      fill="white"
    />
    <path
      d="M218.841 188.369C218.763 188.447 218.763 188.526 218.684 188.605C217.974 189.945 217.265 191.207 216.555 192.547C216.476 192.626 216.398 192.783 216.398 192.862C216.082 193.335 215.215 193.414 214.9 192.862C214.663 192.468 214.506 192.153 214.269 191.758C213.717 190.655 213.165 189.63 212.535 188.526C212.535 188.447 212.456 188.447 212.377 188.29C212.377 188.447 212.377 188.526 212.377 188.605C212.377 190.339 212.377 191.995 212.377 193.729C212.377 193.966 212.298 194.045 212.062 194.045C211.904 194.045 211.668 194.045 211.51 194.045C211.352 194.045 211.352 193.966 211.352 193.887C211.352 191.995 211.352 190.103 211.352 188.211C211.352 187.738 211.668 187.344 212.141 187.186C212.614 187.107 213.008 187.265 213.244 187.738C213.954 189.157 214.742 190.497 215.452 191.916C215.53 191.995 215.53 192.074 215.609 192.153C215.688 192.074 215.767 191.995 215.767 191.916C216.476 190.497 217.265 189.157 217.974 187.738C218.211 187.265 218.684 187.107 219.078 187.186C219.551 187.265 219.787 187.659 219.787 188.211C219.787 190.103 219.787 191.916 219.787 193.808C219.787 194.045 219.709 194.123 219.551 194.045C219.393 194.045 219.236 194.045 219.078 194.045C218.92 194.045 218.841 193.966 218.841 193.808C218.841 193.177 218.841 192.626 218.841 191.995C218.841 190.891 218.841 189.788 218.841 188.605C218.92 188.605 218.92 188.526 218.841 188.369Z"
      fill="white"
    />
    <path
      d="M197.083 190.654C197.083 189.551 197.083 188.526 197.083 187.422C197.083 187.264 197.162 187.186 197.32 187.186C198.66 187.186 200.079 187.186 201.419 187.186C202.286 187.186 202.759 187.659 202.759 188.526C202.759 188.92 202.759 189.314 202.759 189.708C202.759 189.787 202.838 189.945 202.917 189.945C203.548 190.102 203.784 190.497 203.863 191.127C203.863 191.758 203.863 192.467 203.863 193.098C203.784 193.729 203.311 194.123 202.68 194.123C201.183 194.123 199.685 194.123 198.266 194.123C198.029 194.123 197.714 194.123 197.477 194.123C197.241 194.123 197.241 194.044 197.241 193.886C197.083 192.783 197.083 191.679 197.083 190.654ZM200.394 190.891C199.685 190.891 199.054 190.891 198.345 190.891C198.187 190.891 198.108 190.97 198.108 191.127C198.108 191.758 198.108 192.31 198.108 192.94C198.108 193.098 198.187 193.177 198.345 193.177C199.685 193.177 201.025 193.177 202.365 193.177C202.68 193.177 202.838 193.098 202.838 192.704C202.838 192.231 202.838 191.758 202.838 191.364C202.838 191.048 202.68 190.97 202.365 190.891C201.734 190.891 201.104 190.812 200.394 190.891ZM200 189.945C200.552 189.945 201.104 189.945 201.656 189.945C201.813 189.945 201.892 189.866 201.892 189.708C201.892 189.314 201.892 188.92 201.892 188.605C201.892 188.289 201.734 188.21 201.498 188.21C200.473 188.21 199.448 188.21 198.502 188.21C198.345 188.21 198.266 188.289 198.266 188.447C198.266 188.92 198.266 189.314 198.266 189.787C198.266 189.945 198.345 190.024 198.502 190.024C198.896 189.945 199.448 189.945 200 189.945Z"
      fill="white"
    />
    <path
      d="M207.016 194.045C206.228 194.045 205.44 194.045 204.651 194.045C204.415 194.045 204.336 193.966 204.415 193.808C204.415 193.65 204.415 193.493 204.415 193.335C204.415 193.099 204.494 193.099 204.651 193.099C206.07 193.099 207.489 193.099 208.908 193.099C209.618 193.099 209.618 193.02 209.618 192.389C209.618 192.074 209.618 191.758 209.618 191.443C209.618 191.049 209.539 190.891 209.066 190.891C207.883 190.891 206.622 190.891 205.44 190.891C204.809 190.891 204.336 190.497 204.257 189.945C204.178 189.393 204.178 188.763 204.257 188.211C204.336 187.58 204.888 187.265 205.597 187.265C207.016 187.265 208.435 187.265 209.854 187.265C210.012 187.265 210.091 187.344 210.091 187.501C210.091 187.738 210.17 188.053 210.012 188.132C209.854 188.29 209.618 188.211 209.381 188.211C208.199 188.211 207.016 188.211 205.834 188.211C205.361 188.211 205.282 188.29 205.282 188.763C205.282 188.999 205.282 189.315 205.282 189.551C205.282 189.866 205.44 189.945 205.755 189.945C206.937 189.945 208.12 189.945 209.302 189.945C209.46 189.945 209.697 189.945 209.854 190.024C210.406 190.182 210.721 190.655 210.721 191.207C210.721 191.758 210.721 192.31 210.721 192.862C210.721 193.572 210.17 194.123 209.46 194.123C208.672 194.045 207.884 194.045 207.016 194.045Z"
      fill="white"
    />
    <path
      d="M369.571 239.531H6.85849V256.953H369.571V239.531Z"
      fill="#949494"
    />
    <path d="M71.5807 257.269H48.1672V442.37H71.5807V257.269Z" fill="#B3B3B3" />
    <path d="M328.262 257.269H304.849V442.37H328.262V257.269Z" fill="#B3B3B3" />
    <path
      d="M161.766 233.855H72.7632V239.531H161.766V233.855Z"
      fill="#767676"
    />
    <path
      d="M188.412 233.855H161.766V239.531H188.412V233.855Z"
      fill="#8C8C8C"
    />
    <path
      d="M145.684 164.876L63.855 165.112C61.6477 165.112 59.9922 167.083 60.3864 169.291L72.7632 234.092L161.766 233.855L149.153 167.714C148.837 166.058 147.418 164.876 145.684 164.876Z"
      fill="#636363"
    />
    <path
      d="M112.811 200.43C112.416 198.38 112.968 196.646 114.151 196.331C112.889 193.966 111.076 192.31 109.263 192.31C106.74 192.31 105.4 195.542 106.189 199.484C106.977 203.426 109.657 206.658 112.18 206.658C113.52 206.658 114.545 205.712 115.097 204.135C114.072 203.504 113.126 202.085 112.811 200.43Z"
      fill="white"
    />
    <path
      d="M111.246 188.676C111.503 187.262 111.122 186.009 110.394 185.876C109.666 185.743 108.866 186.782 108.609 188.195C108.351 189.609 108.733 190.862 109.461 190.995C110.189 191.127 110.988 190.089 111.246 188.676Z"
      fill="white"
    />
    <path
      d="M338.826 239.373C343.571 239.373 347.418 235.526 347.418 230.781C347.418 226.035 343.571 222.188 338.826 222.188C334.08 222.188 330.233 226.035 330.233 230.781C330.233 235.526 334.08 239.373 338.826 239.373Z"
      fill="#E3E3E3"
    />
    <path
      d="M366.339 164.009C368.82 164.009 370.832 161.997 370.832 159.515C370.832 157.034 368.82 155.022 366.339 155.022C363.857 155.022 361.845 157.034 361.845 159.515C361.845 161.997 363.857 164.009 366.339 164.009Z"
      fill="#E3E3E3"
    />
    <path
      d="M321.537 124.46L307.489 110.413L297.623 120.28L311.67 134.327L321.537 124.46Z"
      fill="#E3E3E3"
    />
    <path
      d="M319.392 126.048C324.159 123.334 325.824 117.269 323.111 112.502C320.397 107.734 314.332 106.069 309.564 108.783C304.796 111.497 303.131 117.562 305.845 122.329C308.559 127.097 314.624 128.762 319.392 126.048Z"
      fill="#E3E3E3"
    />
    <path
      d="M293.054 152.375C297.822 149.661 299.487 143.596 296.773 138.828C294.059 134.061 287.994 132.396 283.226 135.11C278.458 137.823 276.793 143.888 279.507 148.656C282.221 153.424 288.286 155.089 293.054 152.375Z"
      fill="#FFF0B3"
    />
    <path
      d="M297.596 120.256L311.628 134.288L306.662 158.411C306.346 159.83 304.612 160.303 303.666 159.357L272.606 128.297C271.581 127.272 272.133 125.538 273.552 125.301L297.596 120.256Z"
      fill="#E3E3E3"
    />
    <path
      d="M369.571 239.531H308.159V236.22C308.159 233.224 310.603 230.859 313.52 230.859H364.21C367.206 230.859 369.571 233.303 369.571 236.22V239.531Z"
      fill="#E3E3E3"
    />
    <path
      d="M341.664 229.204L336.066 226.996L362.554 160.934L309.027 132.554L311.865 127.272L370.122 158.096L341.664 229.204Z"
      fill="#E3E3E3"
    />
    <defs>
      <radialGradient
        id="paint0_radial"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(189.765 433.751) scale(149.497 12.0051)"
      >
        <stop stopColor="#21045F" />
        <stop offset="1" stopColor="#21045F" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint1_radial"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(189.765 438.097) scale(74.1477 6.50514)"
      >
        <stop stopColor="#21045F" />
        <stop offset="1" stopColor="#21045F" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);
export default BsmBackground;
